import { Brain, Users, Split, ServerCog, BadgeCheck } from "lucide-react";

const stages = [
  {
    icon: Brain, n: "01", title: "Change the mindset",
    desc: "From \"collect whatever we can\" to \"only collect what we can justify\". Delete by default, limit access by role, log every use. It's a culture change first, a technical one second, across leadership, programme staff, field teams and partners.",
    wide: true,
  },
  {
    icon: Users, n: "02", title: "Set up an independent DP team",
    desc: "A small team of 2–5 people that reviews every data collection and can overrule programme teams. No sign-off means no collection.",
  },
  {
    icon: Split, n: "03", title: "Two adoption pathways",
    desc: "New data follows DPDP rules from day one. That's the easier part. Old data across drives and spreadsheets gets deleted unless clearly justified. That's the hard part.",
  },
  {
    icon: ServerCog, n: "04", title: "Prepare for adoption",
    desc: "Data residency in India, consent manager arrangements, data policies, MIS reviews, plus extra care for children's data and persons with disabilities.",
  },
  {
    icon: BadgeCheck, n: "05", title: "Audit & certify",
    desc: "An outside independent agency reviews policies, data and systems, and certifies compliance. You get a certificate you can show the board and donors.",
  },
];

export const Approach = () => (
  <section id="approach" className="py-24">
    <div className="max-w-[1120px] mx-auto px-6">
      <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#9E1B32] bg-[#FBEAEE] px-3 py-1 rounded-full">How we work</span>
      <h2 className="mt-4 text-3xl sm:text-4xl font-bold tracking-tight max-w-[640px]">
        Compliance isn't a one-off task. It's a change the whole organisation goes through, in five stages.
      </h2>
      <div className="mt-12 grid md:grid-cols-2 gap-5">
        {stages.map((s) => (
          <div
            key={s.n}
            data-testid={`stage-card-${s.n}`}
            className={`group rounded-[14px] border border-[#E7E7EC] bg-[#F7F7F8] p-8 hover:shadow-[0_8px_30px_rgb(0,0,0,0.06)] hover:-translate-y-0.5 transition-[box-shadow,transform] ${s.wide ? "md:col-span-2" : ""}`}
          >
            <div className="flex items-center gap-4">
              <span className="w-11 h-11 rounded-[10px] bg-white border border-[#E7E7EC] grid place-items-center text-[#9E1B32]">
                <s.icon size={20} />
              </span>
              <span className="text-sm font-extrabold text-[#F58220]">{s.n}</span>
            </div>
            <h3 className="mt-4 text-xl font-semibold tracking-tight">{s.title}</h3>
            <p className="mt-2 text-[15px] text-[#5C5F6B] leading-relaxed">{s.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Approach;
